import { TweenMax, Power2 } from 'gsap/all';

import Modal from './Modal';

class ModalDefault extends Modal {
  public beforeOpen() {
    const time = 0.8;
    this.$modal.style.visibility = 'visible';
    TweenMax.from(this.$modal, time, {
      ease: Power2.easeOut,
      scale: 1.3,
      opacity: 0,
      onComplete: () => {
        this.$modal.style.transform = '';
        this.$modal.style.opacity = '';
      },
    });
    return this;
  }

  public afterClose() {
    super.afterClose();
    TweenMax.to(this.$modal, 0.8, {
      ease: Power2.easeOut,
      opacity: 0,
      onComplete: () => {
        this.$modal.style.visibility = '';
        this.$modal.style.opacity = '';
      },
    });
    return this;
  }
}

export default ModalDefault;
